import { p } from "./_helpers";

const commerce = {
 slug: "commerce",
 path: "/secteurs/commerce",
 hero: {
 image: "/photos/sector-commerce-hero.jpg",
 alt: p("Commerce urbain à Bissau", "Urban trade in Bissau and Bafatá", "Comércio urbano em Bissau e Bafatá"),
 breadcrumb: p("Commerce", "Commerce", "Comércio"),
 title: p("Investir dans le commerce.", "Investing in commerce.", "Investir no comércio."),
 subtitle: p(
 "Distribution moderne, réseaux de grossistes, e-commerce et concept stores : un marché urbain de 3 millions d'habitants qui monte en gamme.",
 "Modern distribution, wholesale networks, e-commerce and concept stores: an urban market of 3 million people moving upmarket.",
 "Distribuição moderna, redes de grossistas, e-commerce e concept stores: um mercado urbano de 3 milhões de habitantes que sobe de gama."
 ),
 },
 seo: {
 title: p(
 "Investir dans le commerce en Guinée-Bissau | NANDA SÁ",
 "Investing in commerce in Guinea-Bissau | NANDA SÁ",
 "Investir no comércio na Guiné-Bissau | NANDA SÁ"
 ),
 description: p(
 "Distribution moderne, grossistes, e-commerce, retail premium : la structuration du commerce en Guinée-Bissau. Chiffres, opportunités et passerelles NANDA SÁ.",
 "Modern distribution, wholesalers, e-commerce, premium retail: structuring commerce in Guinea-Bissau. Figures, opportunities and NANDA SÁ pathways.",
 "Distribuição moderna, grossistas, e-commerce, retalho premium: a estruturação do comércio na Guiné-Bissau. Dados, oportunidades e pontes NANDA SÁ."
 ),
 keywords: "commerce Guinée-Bissau, distribution Bissau, retail e-commerce Guinée-Bissau, cash & carry Afrique de l'Ouest, concept store premium",
 },
 presentation: {
 title: p("Un marché urbain qui monte en exigence.", "An urban market rising in demand.", "Um mercado urbano em ascensão de exigência."),
 paragraphs: p(
 [
 "Bissau, Bafatá, Canchungo forment un tissu urbain de plus de 3 millions d'habitants dont le pouvoir d'achat progresse chaque année. La classe moyenne émergente, la diaspora qui revient investir et une jeunesse connectée exigent désormais des produits mieux référencés, des espaces de vente organisés et des expériences d'achat comparables aux standards régionaux.",
 "Le commerce reste largement informel : c'est une opportunité. Les investisseurs qui structurent aujourd'hui la distribution moderne, les concept stores, les plateformes e-commerce ou les cash & carry occupent des positions qui deviendront très difficiles à contester.",
 ],
 [
 "Bissau, Bafatá, Canchungo form an urban fabric of over 3 million people whose purchasing power grows each year. The emerging middle class, the returning diaspora, and a connected youth now demand better-referenced products, organised sales spaces and purchasing experiences comparable to regional standards.",
 "Commerce remains largely informal: this is an opportunity. Investors who structure modern distribution, concept stores, e-commerce platforms or cash & carry today occupy positions that will become very difficult to contest.",
 ],
 [
 "Bissau, Bafatá, Canchungo formam um tecido urbano de mais de 3 milhões de habitantes cujo poder de compra progride a cada ano. A classe média emergente, a diáspora que regressa a investir e uma juventude conectada exigem doravante produtos mais bem referenciados, espaços de venda organizados e experiências de compra comparáveis aos padrões regionais.",
 "O comércio permanece largamente informal: é uma oportunidade. Os investidores que estruturam hoje a distribuição moderna, concept stores, plataformas de e-commerce ou cash & carry ocupam posições que se tornarão muito difíceis de contestar.",
 ]
 ),
 },
 kpis: {
 title: p("Chiffres clés du commerce", "Commerce key figures", "Dados-chave do comércio"),
 items: [
 { n: "3 M+", l: p("Population urbaine", "Urban population", "População urbana"), d: p("Bissau, Bafatá, Canchungo.", "Bissau, Bafatá, Canchungo.", "Bissau, Bafatá, Canchungo.") },
 { n: "85 %", l: p("Commerce informel", "Informal trade", "Comércio informal"), d: p("Marché à structurer par la distribution moderne.", "Market to structure via modern distribution.", "Mercado a estruturar pela distribuição moderna.") },
 { n: "€ 400 M", l: p("Consommation urbaine", "Urban consumption", "Consumo urbano"), d: p("Estimation annuelle produits de grande conso.", "Annual estimate consumer goods.", "Estimativa anual bens de grande consumo.") },
 { n: "45 %", l: p("Moins de 25 ans", "Under 25", "Menos de 25 anos"), d: p("Une jeunesse connectée, prête au e-commerce.", "Connected youth, ready for e-commerce.", "Uma juventude conectada, pronta para o e-commerce.") },
 { n: "2h", l: p("Bissau ↔ Bafatá", "Bissau ↔ Bafatá", "Bissau ↔ Bafatá"), d: p("Marché intégré transfrontalier.", "Integrated cross-border market.", "Mercado integrado transfronteiriço.") },
 { n: "0", l: p("Cash & carry majeur", "Major cash & carry", "Cash & carry importante"), d: p("Absence structurelle à combler d'urgence.", "Structural absence to be urgently filled.", "Ausência estrutural a preencher com urgência.") },
 ],
 sources: p(
 "Sources : INE Guinée-Bissau, ANSD Banque mondiale, données 2023-2025.",
 "Sources: INE Guinea-Bissau, ANSD World Bank, data 2023-2025.",
 "Fontes: INE Guiné-Bissau, ANSD Banco Mundial, dados 2023-2025."
 ),
 },
 opportunites: {
 title: p("Segments d'investissement prioritaires", "Priority investment segments", "Segmentos de investimento prioritários"),
 intro: p(
 "Quatre segments à structurer, du proximité au premium.",
 "Four segments to structure, from proximity to premium.",
 "Quatro segmentos a estruturar, do proximidade ao premium."
 ),
 segments: [
 { h3: p("1. Cash & carry et grossistes modernes", "1. Cash & carry and modern wholesalers", "1. Cash & carry e grossistas modernos"),
 p: p("Le maillon logistique-commerce absent. Ticket : 500 000 à 2 M€.", "The missing logistics-commerce link. Ticket: €500k to €2M.", "O elo logístico-comercial em falta. Ticket: 500 000 a 2 M€.") },
 { h3: p("2. Concept stores premium (Bissau)", "2. Premium concept stores (Bissau)", "2. Concept stores premium (Bissau)"),
 p: p("Marques locales & internationales, art de vivre. Ticket : 100 000 à 400 000 €.", "Local & international brands, lifestyle. Ticket: €100k to €400k.", "Marcas locais e internacionais, arte de viver. Ticket: 100 000 a 400 000 €.") },
 { h3: p("3. E-commerce & marketplaces régionales", "3. E-commerce & regional marketplaces", "3. E-commerce e marketplaces regionais"),
 p: p("Paiement mobile, livraison urbaine, retour diaspora. Ticket : 80 000 à 300 000 €.", "Mobile payment, urban delivery, diaspora return. Ticket: €80k to €300k.", "Pagamento móvel, entrega urbana, retorno da diáspora. Ticket: 80 000 a 300 000 €.") },
 { h3: p("4. Franchise & réseau de proximité", "4. Franchise & proximity network", "4. Franquia e rede de proximidade"),
 p: p("Superettes, quincailleries, pharmacies structurées. Ticket : 150 000 à 500 000 €.", "Convenience stores, hardware, structured pharmacies. Ticket: €150k to €500k.", "Superettes, drogarias, farmácias estruturadas. Ticket: 150 000 a 500 000 €.") },
 ],
 },
 defis: {
 title: p("Les défis à anticiper", "Challenges to anticipate", "Desafios a antecipar"),
 intro: p(
 "Le commerce moderne s'appuie sur la discipline logistique et la maîtrise des paiements.",
 "Modern commerce relies on logistics discipline and payment mastery.",
 "O comércio moderno assenta na disciplina logística e no domínio dos pagamentos."
 ),
 items: p(
 [
 "Un pouvoir d'achat inégal — segmentation fine indispensable.",
 "Une chaîne de paiement en transition (cash → mobile money → carte).",
 "Une chaîne du froid et de la conservation à consolider.",
 "Une concurrence informelle qui exige un positionnement clair.",
 ],
 [
 "Uneven purchasing power — fine segmentation indispensable.",
 "A payment chain in transition (cash → mobile money → card).",
 "A cold chain and preservation to consolidate.",
 "Informal competition that requires clear positioning.",
 ],
 [
 "Um poder de compra desigual — segmentação fina indispensável.",
 "Uma cadeia de pagamentos em transição (dinheiro → mobile money → cartão).",
 "Uma cadeia de frio e conservação a consolidar.",
 "Uma concorrência informal que exige um posicionamento claro.",
 ]
 ),
 closing: p(
 "Ces défis sont ceux d'un marché en train de se moderniser. Le premier à s'y positionner avec rigueur en devient la référence.",
 "These challenges are those of a market being modernised. The first to position rigorously becomes the reference.",
 "Estes desafios são os de um mercado em modernização. O primeiro a posicionar-se com rigor torna-se a referência."
 ),
 },
 pourquoi: {
 title: p("La Maison qui connaît le terrain commercial.", "The House that knows the commercial ground.", "A Casa que conhece o terreno comercial."),
 paragraphs: p(
 [
 "NANDA SÁ opère déjà en distribution : NANDA SÁ à Bissau, NANDA SÁ Cosmétiques en concept stores, ENERGIA PRO en B2B professionnel. Nous connaissons les circuits, les enseignes, les distributeurs, les cadres réglementaires et les habitudes d'achat des ménages urbains ouest-africains.",
 ],
 [
 "NANDA SÁ already operates in distribution: NANDA SÁ in Bissau, NANDA SÁ Cosmétiques in concept stores, ENERGIA PRO in professional B2B. We know the circuits, brands, distributors, regulatory frameworks and purchasing habits of West African urban households.",
 ],
 [
 "A NANDA SÁ já opera em distribuição: NANDA SÁ em Bissau, NANDA SÁ Cosmétiques em concept stores, ENERGIA PRO em B2B profissional. Conhecemos os circuitos, insígnias, distribuidores, quadros regulamentares e hábitos de compra dos agregados urbanos oeste-africanos.",
 ]
 ),
 bullets: p(
 [
 "Étude de zone de chalandise et positionnement",
 "Structuration commerciale et category management",
 "Partenariats fournisseurs et enseignes",
 "Digitalisation ventes et paiements",
 ],
 [
 "Catchment area study and positioning",
 "Commercial structuring and category management",
 "Supplier and brand partnerships",
 "Sales and payments digitalisation",
 ],
 [
 "Estudo de área de captação e posicionamento",
 "Estruturação comercial e category management",
 "Parcerias com fornecedores e insígnias",
 "Digitalização de vendas e pagamentos",
 ]
 ),
 },
 download: {
 title: p("Télécharger la note « Commerce · Guinée-Bissau ».", "Download the brief « Commerce · Guinea-Bissau ».", "Descarregar a nota « Comércio · Guiné-Bissau »."),
 body: p(
 "Note préparée par NANDA SÁ : chiffres clés, segments à structurer, cadre réglementaire, contacts utiles.",
 "Brief prepared by NANDA SÁ: key figures, segments to structure, regulatory framework, useful contacts.",
 "Nota preparada pela NANDA SÁ: dados-chave, segmentos a estruturar, enquadramento regulamentar, contactos úteis."
 ),
 pdfUrl: "/pdf/nanda-sa-note-commerce.pdf",
 pdfFilename: "nanda-sa-note-commerce.pdf",
 mailSubject: p("Téléchargement de la note « Commerce »", "Download of the brief « Commerce »", "Descarga da nota « Comércio »"),
 mailBody: p(
 "Bonjour, je souhaite recevoir la note « Commerce · Guinée-Bissau ».",
 "Hello, I would like to receive the brief « Commerce · Guinea-Bissau ».",
 "Olá, gostaria de receber a nota « Comércio · Guiné-Bissau »."
 ),
 },
 contact: {
 title: p("Parlons de votre projet commercial.", "Let's talk about your commercial project.", "Falemos do seu projecto comercial."),
 body: p(
 "Enseigne, franchiseur, e-commerçant, grossiste, investisseur : décrivez votre intention, nous répondons personnellement.",
 "Retailer, franchisor, e-merchant, wholesaler, investor: describe your intention, we respond personally.",
 "Insígnia, franquiador, e-comerciante, grossista, investidor: descreva a sua intenção, respondemos pessoalmente."
 ),
 quote: p(
 "Le commerce n'est pas qu'un échange. C'est aussi le pouls d'une ville.",
 "Commerce is not just an exchange. It is also a city's pulse.",
 "O comércio não é apenas uma troca. É também o pulso de uma cidade."
 ),
 subject: p("Investir dans le commerce en Guinée-Bissau", "Invest in commerce in Guinea-Bissau", "Investir no comércio na Guiné-Bissau"),
 },
 ctas: ["NandaSa", "Energia", "Conseil"],
};

export default commerce;
